import { useEffect, useRef, useState } from "react";
import { useTranslation } from "@scuf/localization";

import "./Summary.scss";
import { StepperProps } from "../createTenantDetails/CreateTenant";
import { AppDispatch, RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettingsByTenantId,
  getTenantDetailsByTenantId,
  setStatusforTenant,
} from "../../../store/Tenant/tenant-actions";
import { IErrorProps, Tenant } from "../../../models";
import Footer from "../Footer/Footer";
import ToastBarForError from "../../SharedComponents/ToastBarForError";
import DialogForError from "../../SharedComponents/DialogForError";
import Loader from "../../Loader/Loader";
import SettingMetaDataDTO from "../../../models/SettingDTO";
import { useNavigate } from "react-router";
import { ToolJiraIcon, Tooltip } from "@forge/common";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import updateErrorList from "../../../utils/methods/updateErrorList";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import GetTokenValues from "../../../utils/methods/GetTokenValues";
import { localeKeyMap } from '../../../localization/keys';

export const Summary: React.FC<StepperProps> = ({
  stepperState,
  setStepperState,
}) => {
  const [t] = useTranslation();
  const dispatch: AppDispatch = useDispatch();

  const [summaryData, setSummarydata] = useState<Array<SettingMetaDataDTO>>([]);

  const tenantDetails: Tenant = useSelector(
    (state: RootState) => state?.cart?.tenantDeatailsByTenantId
  );
  useEffect(() => {
    summaryData.map((prod) => {
      prod.settings.map((set) => {});
    });
  }, summaryData);

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next

  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };
  const parameters: {
    tenantId: string;
  } = {
    tenantId: tokenInfo?.tenant ?? "",
  };
  const navigate = useNavigate();
  const onBackBtn = () => {
    setStepperState({
      ...stepperState,
      currentStep: "Settings",
      steps: stepperState?.steps?.map((step: any) => {
        if (step.id === "Settings") {
          return { ...step, status: undefined };
        }
        if (step.id === "Summary") {
          return { ...step, status: undefined };
        }

        return step;
      }),
    });
  };

  function handleSumbit() {
    setIsLoading(true);
    dispatch(setStatusforTenant(parameters.tenantId))
      .unwrap()
      .then(() => {
        navigate("/tenant/user");
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    setIsLoading(true);
    dispatch(getSettingsByTenantId(parameters.tenantId))
      ?.unwrap()
      ?.then((response: SettingMetaDataDTO[]) => {
        setSummarydata(response);
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <div className="summary-tab color-bg-grey">
        <div className="header-title p-20">
          {t(localeKeyMap.summarySaveToContinue)}
        </div>
        <div className="header-subtitle">
          <div className="summary-title p-b20">{t(localeKeyMap.summaryTitle)}</div>
        </div>

        <div className="info-box">
          <div className="info-row">
            <span className="info-field">{t(localeKeyMap.summaryName)}</span>
            <span className="info-value">{tenantDetails?.tenantName}</span>
          </div>
          <div className="info-row">
            <span className="info-field">{t(localeKeyMap.summaryTenantID)}</span>
            <span className="info-value">{tenantDetails?.tenantId}</span>
          </div>
        </div>

        <div className="summary-box">
          <div className="summary-row">
            {summaryData.map((prod) => {
              return (
                <div className="summary_col">
                  <div className="detail_box p-b10 p-r10">
                    <div className="details-label">{t(localeKeyMap.summarySelectedProduct)}</div>
                    <Tooltip
                      content={prod?.productName}
                      position="bottom-right"
                    >
                      <div className="details-value">{prod?.productName}</div>
                    </Tooltip>
                  </div>

                  {prod?.settings?.map((set) => {
                    return (
                      <>
                        <div className="detail_box p-b10 p-r10">
                          <div className="details-label">
                            {set?.displayName} :
                          </div>
                          <Tooltip content={set?.value} position="bottom-right">
                            <div className="details-value">{set?.value}</div>
                          </Tooltip>
                        </div>
                      </>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>

        {/*settings summary  */}

        <div className="summary-box"></div>
      </div>
      <Footer
        cancelButtonRequired={true}
        cancelBtnLabel={t(localeKeyMap.summaryBack)}
        onBackBtn={onBackBtn}
        createBtnLabel={t(localeKeyMap.summarySave)}
        openDialogCreate={false}
        setOpenDialogCreate={() => {}}
        openDialogonClose={false}
        openDialogCancel={false}
        setOpenDialogCancel={function (value: boolean): void {}}
        checkIfAnyTextFilled={() => {}}
        onSubmit={() => {}}
        validate={() => {
          handleSumbit();
        }}
        // IsNextDisabled={!props?.checkIfTabHasError}
      />
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />} {isLoading && <Loader />}
    </>
  );
};
